<template>
  <div>
    <v-navigation-drawer v-model="drawer" absolute temporary app width="150" height="340">
      <v-list class="pt-4">
        <v-list-tile active-class="blue--text" to="/">
          <v-list-tile-content>
            <v-list-tile-title>HOME</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile active-class="blue--text" to="/resume">
          <v-list-tile-content>
            <v-list-tile-title>RESUME</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <!-- <v-list-tile active-class="blue--text" to="/services">
          <v-list-tile-content>
            <v-list-tile-title>SERVICES</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile> -->
        <v-list-tile active-class="blue--text" to="/portfolio">
          <v-list-tile-content>
            <v-list-tile-title>PORTFOLIO</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <!-- <v-list-tile active-class="blue--text" to="/blog">
          <v-list-tile-content>
            <v-list-tile-title>BLOG</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile> -->
        <v-list-tile active-class="blue--text" to="/contact">
          <v-list-tile-content>
            <v-list-tile-title>CONTACT</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar flat dense color="transparent" scroll-off-screen>
      <v-toolbar-side-icon class="hidden-md-and-up" @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title class="headline">
        <span class="font-weight-light">Alan</span>
        <span class="blue--text">Devalis</span>
        <span class="font-weight-light">v1.2</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn @click="changeTheme" depressed small icon class="hidden-md-and-up">
        <v-icon v-if="goDark==true">fas fa-sun</v-icon>
        <v-icon v-else>fas fa-moon</v-icon>
      </v-btn>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn flat to="/" active-class="blue--text headline">{{$t('home')}}</v-btn>
        <v-btn flat to="/resume" active-class="blue--text headline">{{$t('resume')}}</v-btn>
        <!-- <v-btn flat to="/services" active-class="blue--text headline">Services</v-btn> -->
        <v-btn flat to="/portfolio" active-class="blue--text headline">{{$t('portfolio')}}</v-btn>
        <!-- <v-btn flat to="/blog" active-class="blue--text headline">Blog</v-btn> -->
        <v-btn flat to="/contact" active-class="blue--text headline">{{$t('contact')}}</v-btn>
        
        <!-- Language buttons -->
          <!-- <v-btn @click="changeLanguage('en')" flat class="language-button">{{ $t('en') }}</v-btn>
          <v-btn @click="changeLanguage('es')" flat class="language-button">{{ $t('es') }}</v-btn>
          <v-btn @click="changeLanguage('it')" flat class="language-button">{{ $t('it') }}</v-btn> -->

        <!-- Theme toggle button -->
        <v-btn @click="changeTheme" depressed small icon>
          <v-icon v-if="goDark==true">fas fa-sun</v-icon>
          <v-icon v-else>fas fa-moon</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
  </div>
</template>

<script>
export default {
  props: {
    goDark: {
      type: Boolean
    }
  },
  data() {
    return {
      drawer: null,
      isLanguageMenuOpen: false,
      langs: [
        { lang: 'en', link: 'https://i.imgur.com/q4q753P.png' },
        { lang: 'es', link: 'https://i.imgur.com/R9jmlon.png' },
        { lang: 'it', link: 'https://i.imgur.com/ahImfkB.png' },
      ],
    };
  },
  methods: {
    changeTheme() {
      this.$emit("changeTheme", this.goDark);
    },
    
    changeLanguage(lang) {
      // Set the new locale using the i18n instance
      this.$i18n.locale = lang;

      // Optionally, you can save the selected language in your component's data
      this.selectedLang = lang;
    },
  }
};
</script>

<style scoped>
.language-button {
  width: 32px; /* Set a fixed width for each language button */
  text-align: center;
}

</style>
